"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameVars = void 0;
var GameVars = /** @class */ (function () {
    function GameVars() {
    }
    GameVars.areValidDomains = function (domains) {
        if (domains.length === 0) {
            return true;
        }
        var hostname = window.location.hostname;
        var referrer = document.referrer;
        var isValid = false;
        for (var i = 0; i < domains.length; i++) {
            if (hostname.indexOf(domains[i]) !== -1) {
                isValid = true;
                break;
            }
        }
        if (referrer) {
            isValid = false;
            for (var i = 0; i < domains.length; i++) {
                if (referrer.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }
        }
        return isValid;
    };
    GameVars.formatNumber = function (value) {
        var ret;
        var suffix;
        if (value >= 1e15) {
            value /= 1e15;
            suffix = "q";
        }
        else if (value >= 1e12) {
            value /= 1e12;
            suffix = "t";
        }
        else if (value >= 1e9) {
            value /= 1e9;
            suffix = "b";
        }
        else if (value >= 1e6) {
            value /= 1e6;
            suffix = "m";
        }
        else if (value >= 1e3) {
            value /= 1e3;
            suffix = "k";
        }
        value = Math.floor(value * 10) / 10;
        if (suffix) {
            ret = value.toString() + suffix;
        }
        else {
            ret = value.toString();
        }
        return ret;
    };
    GameVars.getNumActiveCells = function () {
        var ret = 0;
        for (var r = 0; r < GameVars.modeGameData.boardConfiguration.length; r++) {
            for (var c = 0; c < GameVars.modeGameData.boardConfiguration[0].length; c++) {
                var cellData = GameVars.modeGameData.boardConfiguration[r][c];
                if (cellData.n !== -1) {
                    ret++;
                }
            }
        }
        return ret;
    };
    GameVars.generateSerie = function (pprev, prev, func, maxValue, length, minValue) {
        var mexp = require("math-expression-evaluator");
        var ret = [];
        var i = 0;
        var end = false;
        var stopGeneratingByLength = false;
        var stopGeneratingByMaxValue = false;
        if (length) {
            stopGeneratingByLength = true;
        }
        if (maxValue) {
            stopGeneratingByMaxValue = true;
        }
        do {
            var value = void 0;
            if (i === 0) {
                value = pprev;
            }
            else if (i === 1) {
                value = prev;
            }
            else {
                pprev = ret[i - 2];
                prev = ret[i - 1];
                var funcAux = func.replace(/i/g, i.toString());
                funcAux = funcAux.replace(/pprev/g, pprev.toString());
                funcAux = funcAux.replace(/prev/g, prev.toString());
                value = Math.round(mexp.eval(funcAux));
            }
            if (stopGeneratingByLength) {
                if (i < length) {
                    ret[i] = value;
                }
                else {
                    end = true;
                }
            }
            else {
                if (stopGeneratingByMaxValue) {
                    if (value <= maxValue) {
                        ret[i] = value;
                    }
                    else {
                        ret[i] = maxValue;
                        end = true;
                    }
                }
                else {
                    if (value >= minValue) {
                        ret[i] = value;
                    }
                    else {
                        end = true;
                    }
                }
            }
            i++;
        } while (!end);
        return ret;
    };
    GameVars.roundValues = function (values, zeroes) {
        var ret = [];
        var n = Math.pow(10, zeroes);
        for (var i = 0; i < values.length; i++) {
            var value = void 0;
            if (values[i] <= n) {
                value = values[i];
            }
            else {
                value = Math.round(values[i] / n) * n;
            }
            ret.push(value);
        }
        return ret;
    };
    return GameVars;
}());
exports.GameVars = GameVars;
